import { call } from '@advanza/api'
import { Col, Row } from '@advanza/grid'
import { InputField } from '@advanza/input'
import { useActionModal } from '@advanza/modal'
import { Button, Icon } from '@advanza/ui'
import { CountryCode } from '@trustoo/types/locale'
import { useBansList } from 'components/bans/BansList'
import Restricted from 'components/Restricted'
import { useAppSelector } from 'hooks/hooks'
import { useState } from 'react'

const FIELDS = [
    'advanza_id',
    'business_name',
    'kvk',
    'phone',
    'email',
    'street_number',
    'street',
    'postalcode',
    'place_name',
    'country_code',
] as const

interface FieldValue extends Partial<Record<(typeof FIELDS)[number], string>> {
    country_code: CountryCode
}

const AddBanButton = () => {
    const { changeFilter } = useBansList()
    const { openModal, renderModal } = useActionModal()
    const { countries } = useAppSelector((state) => state.countries)
    const [fieldValues, setFieldValues] = useState<FieldValue>({
        country_code: countries[0],
    })
    const invalidate = () => changeFilter({ didInvalidate: true, page: 0, result: {} })

    const onAddBan = () =>
        call(`office/providers-bans/add-ban`, { json: fieldValues }).then(() => {
            setFieldValues({ country_code: countries[0] })
            invalidate()
        })

    return (
        <Restricted location="providers">
            <Button onClick={() => openModal()}>
                <Icon name="add" /> Add ban
            </Button>
            {renderModal({
                cancelText: 'Cancel',
                text: 'Ok',
                func: onAddBan,
                header: 'Add ban',
                body: FIELDS.map((field) => (
                    <Row key={field} middle="xs">
                        <Col xs={3}>{field.replace(/_/g, ' ')}</Col>
                        <Col xs={6}>
                            <InputField
                                value={fieldValues[field]}
                                onChange={(e) =>
                                    setFieldValues((fieldValues) => ({
                                        ...fieldValues,
                                        [field]: e.target.value,
                                    }))
                                }
                            />
                        </Col>
                    </Row>
                )),
            })}
        </Restricted>
    )
}

export default AddBanButton
